import React from 'react';
import BackgroundSquares from './Background';
import Logo from './Logo';
import Footer from './Footer';

interface PageLayoutProps {
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl';
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

const maxWidthClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '4xl': 'max-w-4xl',
};

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = 'md',
  className = '',
}) => {
  return (
    <>
      <BackgroundSquares />
      <div className="relative min-h-screen px-[40px] z-10 grid grid-rows-[auto_1fr_auto]">
        <Logo className="pt-8 pb-6 tabletMd:pt-10 tabletMd:pb-8 desktopSm:pt-12 desktopSm:pb-10" />
        <div
          className={`flex flex-col items-center justify-center w-full ${maxWidthClasses[maxWidth]} mx-auto ${className}`}
        >
          {children}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PageLayout;
